import { useEffect, useState } from 'react';

/** Live `window.matchMedia(query).matches` (false on the server and in old browsers). */
export function useMediaQuery(query) {
  const get = () => (typeof window !== 'undefined' && window.matchMedia ? window.matchMedia(query).matches : false);
  const [matches, setMatches] = useState(get);
  useEffect(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return undefined;
    const mql = window.matchMedia(query);
    const on = () => setMatches(mql.matches);
    on();
    mql.addEventListener('change', on);
    return () => mql.removeEventListener('change', on);
  }, [query]);
  return matches;
}

/** Phone width (below Tailwind's `sm`). */
export const usePhone = () => useMediaQuery('(max-width: 639px)');
